import tw, { css, styled } from 'twin.macro'

import { Link } from 'gatsby'

export const HeroSection = styled.section`
	${tw`flex flex-col w-full items-center bg-center bg-no-repeat bg-cover relative overflow-hidden`}
	background-image: url(${({ sources }) => sources[0].base64});

	@media (min-width: 375px) {
		height: 230px;
		max-height: 230px;
	}

	@media (min-width: 525px) {
		height: 320px;
		max-height: 320px;
	}

	@media (min-width: 768px) {
		height: 440px;
		max-height: 440px;
	}

	@media (min-width: 1024px) {
		height: 580px;
		max-height: 580px;
	}
	@media (min-width: 1280px) {
		height: 750px;
		max-height: 750px;
	}
`
export const HeroItemsContainer = styled.div`
	${tw`absolute flex flex-col w-full m-auto items-center justify-center h-full pb-4 pt-8 lg:p-0`}
	top:0;
	left: 0;
	right: 0;

	> svg {
		@media(min-width: 525px) {
			${tw`w-8/12`}
		}
		${tw`w-7/12 md:w-auto!`}
	}

	> svg#ecoclear-swim-logo {
		filter: drop-shadow(1px 4px 4px rgba(0,0,0,0.625));
	}

	${tw`bg-cover bg-no-repeat bg-center`}
	@media (min-width: 1350px) {
		${tw`bg-bottom`}
		background-image: url(${({ sources }) => (sources ? sources[0].srcWebp : '')});
		background-image: url(${({ sources }) => (sources ? sources[0].src : '')});
	}
	@media (min-width: 1280px) and (max-width: 1349px) {
		background-image: url(${({ sources }) => (sources ? sources[1].srcWebp : '')});
		background-image: url(${({ sources }) => (sources ? sources[1].src : '')});
	}
	@media (min-width: 1024px) and (max-width: 1279px) {
		background-image: url(${({ sources }) => (sources ? sources[2].srcWebp : '')});
		background-image: url(${({ sources }) => (sources ? sources[2].src : '')});
	}
	@media (min-width: 768px) and (max-width: 1023px) {
		background-image: url(${({ sources }) => (sources ? sources[3].srcWebp : '')});
		background-image: url(${({ sources }) => (sources ? sources[3].src : '')});
	}
	@media (max-width: 767px) {
		background-image: url(${({ sources }) => (sources ? sources[4].srcWebp : '')});
		background-image: url(${({ sources }) => (sources ? sources[4].src : '')});
	}
`
export const HeroButtons = styled.div`
	@media (min-width: 525px) {
		${tw`flex-row mt-4`}
	}
	${tw`flex flex-col mt-2 lg:mt-8`}
`
export const HeroSeeAllLink = styled(Link)`
	@media (min-width: 525px) {
		${tw`mb-0 mr-2`}
	}
	${tw`border border-yellow-500 bg-yellow-500 text-gray-800 hover:border-yellow-400 hover:bg-yellow-400 rounded mb-2 mr-0 text-center`}
`
export const HeroSeeAll = styled.button`
	@media (min-width: 525px) {
		${tw`text-sm`}
	}
	${tw`font-sans uppercase text-xs md:text-base py-2 lg:py-4 px-8 leading-none w-full`}
`
export const HeroBookLink = styled(Link)`
	@media (min-width: 525px) {
		${tw`ml-2`}
	}
	${tw`border border-mineral-teal rounded bg-mineral-teal hover:bg-blue-600 hover:border-blue-600 ml-0 text-center`}
`
export const HeroBook = styled.button`
	@media (min-width: 525px) {
		${tw`text-sm`}
	}
	${tw`font-display text-white leading-none text-xs md:text-base uppercase py-2 lg:py-4 px-8 `}
`
export const Bold = tw.b`font-bold`
export const Heading1 = styled.h1`
	@media (min-width: 525px) {
		${tw`text-3xl my-4`}
	}
	${tw`font-display text-greyish-blue font-bold text-xl md:text-4xl lg:text-5xl text-center my-2 md:my-8 md:w-8/12 xxxl:w-6/12`}
`
export const BannerText = styled.p`
	@media (min-width: 525px) {
		${tw`block text-lg`}
	}
	${tw`font-display text-greyish-blue font-bold hidden md:text-2xl xl:text-3xl`}
`

export const PageBodySection = tw.section`border-b border-gray-400 w-full py-12`
export const PageBodyContainer = tw.div`w-10/12 md:w-8/12 mx-auto flex flex-col items-center justify-center`
export const BodyHead = tw.h2`text-3xl text-blue-500 font-display mb-3 text-center font-bold`
export const BodyText = tw.p`text-xl font-display text-center`

export const ProductSection = tw.section`w-full my-4`
export const ProductsContainer = tw.div`w-95 md:w-11/12 mx-auto flex flex-row flex-wrap`
export const PaddingItemHolder = tw.div`px-4 w-full sm:w-6/12 lg:w-4/12 mb-4 lg:mb-0`
export const ItemContainer = styled.div`
	box-shadow: 0 20px 25px -5px rgba(0, 0, 0, 0.1),
		0 10px 10px -5px rgba(0, 0, 0, 0.04);
	${tw`p-4 h-full flex justify-end flex-col`}
`
export const ItemImageContainer = styled.div`
	max-height: 300px;
	transition: all 0.3s ease-in-out;
	${tw`flex items-center justify-center py-8 px-4 h-screen cursor-pointer hover:bg-gray-100`}

	img {
		${tw`h-full`}
		max-height: 300px;
	}
`
export const NullText = tw.p`font-display text-white text-center uppercase text-xl`
export const DetailsContainer = tw.div`my-4 flex flex-col`
export const ButtonsContainer = tw.div`flex flex-row items-center mt-auto mb-4 w-10/12 md:w-full mx-auto`
export const AddToCart = styled.button`
	${tw`font-display w-full md:w-6/12 uppercase border border-yellow-600 hover:border-yellow-500 bg-yellow-600 hover:bg-yellow-500 text-white py-2 text-sm px-2 rounded cursor-pointer mr-1`}
	&[disabled] {
		${tw`cursor-not-allowed`}
	}
`
export const Enquire = styled(Link)`
	${tw`font-display text-center w-full md:w-6/12 uppercase border border-yellow-600 hover:border-yellow-500 bg-yellow-600 hover:bg-yellow-500 text-white py-2 text-sm px-2 rounded cursor-pointer mr-1`}
`
export const EnquireZa = styled(Link)`
	${tw`font-display text-center w-full uppercase border border-yellow-600 hover:border-yellow-500 bg-yellow-600 hover:bg-yellow-500 text-white py-2 text-sm px-2 rounded cursor-pointer mr-1`}
`
export const Details = styled.div`
	${tw`font-display w-full md:w-6/12 uppercase text-center border border-blue-700 bg-white hover:bg-blue-700 text-blue-700 hover:text-white py-2 text-sm rounded cursor-pointer ml-1`}
`
export const ProductName = tw.p`font-display uppercase font-bold mb-2 w-full text-center`
export const ProductPrice = tw.p`text-sm font-display mb-2 w-full text-center`
export const ProductBlurb = tw.p`text-sm font-display mb-2 w-full text-center`

export const ProdHeading1 = styled.h1`
	${tw`font-display font-bold text-4xl mb-6 text-blue-500 bg-gray-200 py-2 pl-6 pl-6 pr-2 border-l-4 border-blue-500 uppercase`}
`
export const ProdHeading2 = styled.h2`
	${tw`font-display font-bold text-3xl mb-6 text-blue-500 bg-gray-200 py-2 pl-6 pl-6 pr-2 border-l-4 border-blue-500 uppercase mt-4`}
`
export const ProdHeading3 = styled.h3`
	${tw`font-display font-bold text-2xl mb-6 text-blue-500 bg-gray-200 py-2 pl-6 pl-6 pr-2 border-l-4 border-blue-500 uppercase mt-4`}
`
export const ProdHeading4 = styled.h4`
	${tw`font-display font-bold text-xl mb-6 text-blue-500 bg-gray-200 py-2 pl-6 pl-6 pr-2 border-l-4 border-blue-500 uppercase mt-4`}
`
export const ProdHeading5 = styled.h5`
	${tw`font-display font-bold text-lg mb-6 text-blue-500 bg-gray-200 py-2 pl-6 pl-6 pr-2 border-l-4 border-blue-500 uppercase mt-4`}
`
export const ProdHeading6 = styled.h6`
	${tw`font-display font-bold text-base mb-6 text-blue-500 bg-gray-200 py-2 pl-6 pl-6 pr-2 border-l-4 border-blue-500 uppercase mt-4`}
`
export const Italic = tw.i`italic`
export const UnorderedList = styled.ul`
	${tw`mx-8 px-4 mb-2`}

	> li {
		${tw`list-disc`}
	}
	> li > p {
		${tw`text-base pl-0`}
	}
`
export const Text = tw.p`font-display text-lg mb-2 leading-snug tracking-wide px-4`
export const ProductDetailsSection = tw.section`w-full`
export const ProductDetailsContainer = tw.div`w-95 md:w-10/12 mx-auto flex flex-col`
export const ProductDetail = tw.div`flex flex-col`

export const TableSection = tw.section`w-full`
export const TableContainer = tw.div`w-95 md:w-10/12 mx-auto`
export const Table = styled.table`
	${tw`w-full border-collapse border-t border-gray-300`}

	tr > th {
		${tw`py-4 font-display bg-blue-400 border-2 border-gray-100 uppercase font-normal text-sm sm:text-base`}
	}
	tr > td:not(.note) {
		${tw`font-display uppercase font-normal border-2 border-gray-100 text-center py-4 text-sm sm:text-base`}
		&.subhead {
			${tw`font-display uppercase font-normal bg-gray-200 border-2 border-gray-100 text-center py-4 text-sm sm:text-base`}
		}
	}

	tr > td.note {
		${tw`font-display py-4 text-center text-sm sm:text-base`}
	}
`

export const EndBannerSection = styled.section`
	${tw`flex flex-col w-full items-center bg-center bg-no-repeat bg-cover relative overflow-hidden my-4 md:my-10`}
	background-image: url(${({ sources }) => sources[0].base64});

	@media (min-width: 320px) {
		height: 300px;
		max-height: 300px;
	}

	@media (min-width: 525px) {
		height: 350px;
		max-height: 350px;
	}

	@media (min-width: 768px) {
		height: 400px;
		max-height: 400px;
	}

	@media (min-width: 1280px) {
		height: 450px;
		max-height: 450px;
	}
`
export const EndBannerContainer = styled.div`
	${tw`absolute flex flex-col w-full m-auto justify-center h-full pb-4 pt-8 lg:pb-0 lg:pt-0`}
	top:0;
	left: 0;
	right: 0;

	${tw`bg-cover bg-no-repeat bg-center`}
	@media (min-width: 320px) {
		background-image: url(${({ sources }) =>
			sources ? sources[2].srcWebp : ''});
		background-image: url(${({ sources }) => (sources ? sources[2].src : '')});
	}
	@media (min-width: 768px) {
		background-image: url(${({ sources }) =>
			sources ? sources[1].srcWebp : ''});
		background-image: url(${({ sources }) => (sources ? sources[1].src : '')});
	}
	@media (min-width: 1024px) {
		background-image: url(${({ sources }) =>
			sources ? sources[0].srcWebp : ''});
		background-image: url(${({ sources }) => (sources ? sources[0].src : '')});
	}
`
export const EndItemImage = tw.img`w-11/12 sm:w-10/12 lg:w-auto`
export const EndBannerText = styled.p`
	${tw`text-white font-display text-3xl sm:text-4xl lg:text-5xl`}
	text-shadow: 10px 6px 8px rgba(0,0,0,.75);
`
export const EndDetailsContainer = tw.div`w-7/12 lg:w-6/12 ml-4 sm:ml-8 lg:ml-16`
export const EndBannerButton = tw.button`py-3 px-4 bg-yellow-500 hover:bg-yellow-400 rounded mt-8`
export const EndBannerLink = styled(Link)`
	${tw`text-white uppercase font-display`}
`
